<script lang="ts">
	import type { HTMLAttributes } from "svelte/elements";
	import type { WithElementRef } from "bits-ui";
	import { cn } from "@/helpers/tw-utils.js";
	import { onMount, onDestroy } from "svelte";

	let {
		ref = $bindable(null),
		class: className,
		children,
		open = $bindable(false),
		...restProps
	}: WithElementRef<HTMLAttributes<HTMLDivElement>> & {
		open?: boolean;
	} = $props();

	// Tawk.to Live chat will be hidden when the dialog is opened
	const manageTawkWidget = () => {
		try {
			if (open) {
				window.Tawk_API.showWidget();
			} else {
				window.Tawk_API.hideWidget();
			}
		} catch (error) {
			console.error("Failed to manage Tawk.to widget:", error);
		}
	};

	$effect(() => {
		manageTawkWidget();
	});

	onMount(() => {
		manageTawkWidget();
	});

	onDestroy(() => {
		try {
			window.Tawk_API.showWidget();
		} catch (error) {
			console.error("Failed to show Tawk.to widget on destroy:", error);
		}
	});
</script>

<div
	bind:this={ref}
	class={cn("flex flex-col space-y-1.5 text-center sm:text-left", className)}
	{...restProps}
>
	{@render children?.()}
</div>
